import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'
import { KdDateRangeSelect } from 'kuaidong-ui'
import { UIUtil } from 'kuaidong-lib'


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterPannel',
  props: {
    visible: { type: Boolean },
    options: null,
    value: null,
    title: null,
    type: null,
    multiple: { type: Boolean },
    startDate: null,
    endDate: null
  },
  emits: ["input", "reset", "confirm", "update:visible"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: string | string[]): void
  (e: 'reset'): void
  (e: 'confirm', value: string | string[], date?: [Date, Date]): void
  (e: 'update:visible', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  visible: boolean
  options: { label: string; value: string; children?: { label: string; value: string }[] }[]
  value: string | string[]
  title?: string
  type?: 'date-range' | 'class'
  multiple?: boolean
  startDate?: Date
  endDate?: Date
};





const innerValue = ref(props.value)

const dateRange = ref([props.startDate, props.endDate])

const isDateRangeType = computed(() => {
  return props.type === 'date-range'
})

const isClassType = computed(() => {
  return props.type === 'class'
})

function clickItem(value: string) {
  if (props.multiple) {
    if (innerValue.value.includes(value)) {
      innerValue.value = (innerValue.value as string[]).filter((item) => item !== value)
    } else {
      innerValue.value = [...(innerValue.value as string[]), value]
    }
  } else {
    innerValue.value = value
  }

  if (isDateRangeType.value) {
    dateRange.value = [undefined, undefined]
  }
}

function close() {
  emit('update:visible', false)
}

function reset() {
  emit('reset')
  close()
}

function confirm() {
  if (isDateRangeType.value && innerValue.value === 'custom') {
    if (dateRange.value.length !== 2 || !dateRange.value[0] || !dateRange.value[1]) {
      UIUtil.showToast('请选择开始和结束时间')
      return
    }
    if (dateRange.value[0] > dateRange.value[1]) {
      UIUtil.showToast('开始时间不能晚于结束时间')
      return
    }
    const afterDate = new Date(dateRange.value[0])
    afterDate.setMonth(afterDate.getMonth() + 6)
    if (afterDate < dateRange.value[1]) {
      UIUtil.showToast('最多只能查看6个月数据')
      return
    }
    emit('input', innerValue.value)
    emit('confirm', innerValue.value, dateRange.value as [Date, Date])
    close()
    return
  }

  emit('input', innerValue.value)
  emit('confirm', innerValue.value)
  close()
}

return { __sfc: true,props, emit, innerValue, dateRange, isDateRangeType, isClassType, clickItem, close, reset, confirm, KdDateRangeSelect }
}

})